import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { SERVICE_IMG } from "@/data/company";
import { Icon } from "@/lib/icons";
import { Reveal } from "@/components/site/Reveal";
import { useSeo } from "@/lib/useSeo";

export default function Services() {
  useSeo("Nos services de maçonnerie & aménagements extérieurs",
    "Maçonnerie générale, béton, murs et clôtures, VRD, rénovation et finitions. SMT Provence intervient dans tout le département des Bouches-du-Rhône.");
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="pt-32 pb-16 bg-ink">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="overline text-primary">Nos domaines d'intervention</span>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white">Nos services</h1>
          <p className="mt-4 text-white/70 max-w-2xl">De la fondation à la finition, SMT Provence prend en charge l'ensemble de vos travaux de maçonnerie et d'aménagement extérieur.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 space-y-20">
        {services.map((s, i) => (
          <Reveal key={s.slug}>
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <div className="overflow-hidden rounded-2xl aspect-[4/3] [direction:ltr]">
                <img src={fileUrl(SERVICE_IMG[s.slug])} alt={s.title} className="w-full h-full object-cover" />
              </div>
              <div className="[direction:ltr]">
                <div className="h-12 w-12 rounded-xl bg-primary flex items-center justify-center text-white mb-4"><Icon name={s.icon} size={24} /></div>
                <h2 className="font-heading text-3xl font-black text-ink">{s.title}</h2>
                <p className="mt-4 text-ink/70 leading-relaxed">{s.short}</p>
                <Link to={`/services/${s.slug}`} data-testid={`service-link-${s.slug}`} className="mt-6 inline-flex items-center gap-2 bg-ink text-white px-6 py-3 rounded-full font-bold hover:bg-primary transition">
                  En savoir plus <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
